import React, { useState, useCallback, useEffect } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import Filter from "../../components/Filter/Filter";

import {
    fetchAPIData,
    getCompanyId,
    getToken,
    getUser,
    compareNameIgnoreCase,
    copyToClipboard,
    cleanObject,
    generateHiddenColumns,
    hasPermission,
    assetsPermissionOptions,
    assetsUseManageOptions,
    createFilterOptions, createSortFieldOptions
} from '../../Utils/Common';
import { handleSave } from '../../components/FormDialog/FormDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Table, { renderCellExpand } from '../../components/Table/Table';
import { GridActionsCellItem } from "@mui/x-data-grid";
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import InfoIcon from '@mui/icons-material/Info';
import HtmlTooltip from "../../components/HtmlToolTip/HtmlToolTip";
import ActionDialog from "../../components/Dialogs/ActionDialog";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";
import axios from 'axios';
import "../pages.scss";
import { usePersistentStorage } from "../../Utils/usePersistentStorage";
import Ajv from "ajv";
import CoreDocumentsDialog from "./CoreDocumentsDialog";
import DocumentIDPWorkflowStatusDialog from "./DocumentIDPWorkflowStatusDialog";
//import sharedContext from "../../contexts/shared-context";
//const coreDocumentsSchema = require("../../json/documentCoreSchema.json").create;
const coreDocumentsSchema = require("../../json/documentCoreSchema.json").update;
//const idpWorkflowCoreDocumentStatusSchemaView = require("../../json/idpWorkflowDocumentStatusSchema.json").view;

const ajv = new Ajv({ strict: false });

const uiSchema = {
    "metadata": {
        "ui:options": {
            orderable: false
        }
    }
};

const MetadataComponent = React.forwardRef(function MetadataComponent(props, ref) {
    return <div {...props} ref={ref}>
        {props.children}
    </div>
});

const DocumentCoreTabPanel = ({ setNotify }) => {
    const { permissions } = usePermissionContext();
    const [apiData, setApiData] = useState([]);
    const [rowJsonData, setRowJsonData] = useState({});
    //const [idpWorkflowStatusData, setidpWorkflowStatusData] = useState([]);
    const [idpWorkflowCoreDocumentStatusJsonData, setIdpWorkflowCoreDocumentStatusJsonData] = useState([]);
    const [open, setOpen] = useState(false);
    const [openIdpWorkflowCoreDocumentStatusDialog, setOpenIdpWorkflowCoreDocumentStatusDialog] = useState(false);
    const [mode, setMode] = useState('view');  // default to view mode
    //const [idpWorkflowCoreDocumentStatusMode, setIdpWorkflowCoreDocumentStatusMode] = useState('view');  // default to view mode
    const [readOnly, setReadOnly] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmProps, setConfirmProps] = useState({});

    //const [openIdpWorkflowStatusDialog, setOpenIdpWorkflowStatusDialog] = useState(false);

    const formId = 'CoreDocumentsDialog';
    const saveButtonText = "Save Core Documents";

    const [reload, setReload] = useState(false);

    const [isLoading, setIsloading] = useState(false);

    const [coreDocuments, setCoreDocuments] = usePersistentStorage("coreDocuments", []);

    useEffect(() => {
        setApiData(coreDocuments);
    }, []);


    // get company id from header using sharedcontext
    //const globalCompanyId = Number(React.useContext(sharedContext));

    const origination = "CORE";

    const idpCoreWorkflowInstructions = "Click the 'Process State' cell link in order to view IDP Core workflow status";

    // API URL is dynamic in that COMPANY_ID is replaced
    const apiURL = '/api/companies/%COMPANY_ID%/coreDocuments?';

    const totalLabel = "Matching Core Documents";
    const viewTitle = "IDP Workflow Document Core Status Information";
    const jsonDataName = "IDP workflow Core document status";

    const fieldData = [
        'documentGUID', 'name',
        'documentType', 'documentTypeId', 'documentTypeLabel',
        'mimeType', 'size', 'state', 'pageCount', 'mlEnabled',
        'trashDate', 'createdDate', 'modifiedDate'
    ];

    const hasAssetsUseManage = hasPermission(permissions, assetsUseManageOptions);

    const sortFieldData = [
        // {
        //     field: 'companyId',
        //     label: 'Company ID'
        // },
        {
            field: 'documentGUID',
            label: 'Document GUID'
        },
        {
            field: 'name',
            label: 'Name'
        },
        {
            field: 'documentType',
            label: 'Document Type'
        },
        {
            field: 'size',
            label: 'Size'
        },
        {
            field: 'state',
            label: 'State'
        },
        {
            field: 'trashDate',
            label: 'Trash Date'
        },
        {
            field: 'createdDate',
            label: 'Created Date'
        },
        {
            field: 'modifiedDate',
            label: 'Modified Date'
        }
    ];


    const columns = [
        // {
        //     field: 'id',
        //     type: 'number',
        //     headerName: 'ID',
        //     hide: true,
        //     minWidth: 50,
        //     flex: 1,
        //     headerAlign: 'left',
        //     align: 'left',
        // },
        {
            field: 'actions',
            hideable:false,
            type: 'actions',
            headerName: 'Actions',
            minWidth: 130,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            getActions: (params) => getActionButtons(params)
        },
        {
            field: 'companyId',
            hideable:false,
            headerName: 'Company ID',
            type: 'number',
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                return params.value.toString();
            }
        },
        {
            field: 'documentGUID',
            hideable:false,
            headerName: 'Document GUID',
            minWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '275px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document GUID" onClick={(event) => copyToClipboard(event, params.row.documentGUID)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'name',
            hideable:false,
            headerName: 'Name',
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            // renderCell: renderCellExpand,
            renderCell: (params) => {
                return (
                    <div className="guidContent">
                        <div style={{ width: '110px', overflow: "hidden", textOverflow: "ellipsis" }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy name" onClick={(event) => copyToClipboard(event, params.row.name)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'documentType',
            hideable:false,
            headerName: 'Document Type',
            minWidth: 250,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'documentTypeId',
            headerName: 'Document Type ID',
            hide: true,
            minWidth: 325,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (

                    <div className="guidContent">
                        <div style={{ width: '275px' }}>
                            {params.value}
                        </div>
                        {params.value &&
                            <div>
                                <Tooltip title="Copy to clipboard" arrow placement="right">
                                    <IconButton aria-label="copy document type GUID" onClick={(event) => copyToClipboard(event, params.row.documentTypeId)}>
                                        <CopyIcon sx={{ fontSize: 'small' }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: 'documentTypeLabel',
            headerName: 'Document Type Label',
            hide: true,
            minWidth: 150,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'processStartTime',
            hideable:false,
            headerName: 'Process Start Time',
            minWidth: 275,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            valueFormatter: (params) => {
                let formattedStartTime = "";
                if (params.value > 0) {
                    formattedStartTime = new Date(params.value).toISOString();
                }
                return formattedStartTime;
            },
            valueParser: (value) => {
                const date = new Date(value);
                return date.getTime();
            }
        },
        {
            field: 'mlEnabled',
            hideable:false,
            headerName: 'ML Enabled',
            type: 'boolean',
            minWidth: 100,
            maxWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return (
                    <>
                        {params.value ? 'Y' : 'N'}
                    </>
                );
            }
        },
        {
            field: 'mimeType',
            hideable:false,
            headerName: 'Mime Type',
            minWidth: 125,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'size',
            hideable:false,
            headerName: 'Size (MB)',
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'state',
            hideable:false,
            headerName: 'State',
            minWidth: 175,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            cellClassName: 'state-header',
            renderHeader: (params) => {
                return (
                    <>
                        <span style={{ fontWeight: 500 }}>{params.colDef.headerName}</span>
                        <Tooltip title={idpCoreWorkflowInstructions} arrow placement="top">
                            <InfoIcon style={{ verticalAlign: 'middle', marginLeft: '5px' }} />
                        </Tooltip>
                    </>
                );
            },
            renderCell: (params) => {
                return (
                    <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            // get json data
                            fetchIdpWorkflowCoreDocumentStatus(params.row.companyId, params.row.documentGUID, params.row.state);

                        }}
                    >
                        {params.value}
                    </Link>
                );
            },
        },
        {
            field: 'pageCount',
            hideable:false,
            headerName: 'Page Count',
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'trashDate',
            hideable:false,
            headerName: 'Trash Date',
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'tables',
            headerName: 'Tables',
            hide: true,
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'pages',
            headerName: 'Pages',
            hide: true,
            minWidth: 100,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: "fileDownloadUrl",
            headerName: "File Download URL",
            hide: true,
            minWidth: 250,
            //maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: "fileUploadUrl",
            headerName: "File Upload URL",
            hide: true,
            minWidth: 250,
            //maxWidth: 200,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand
        },
        {
            field: 'lastContentUpdatedDate',
            headerName: 'Last Content Updated Date',
            hide: true,
            minWidth: 210,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'lastContentUpdatedUserId',
            headerName: 'Last Content Updated UserId',
            hide: true,
            minWidth: 210,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'createdDate',
            headerName: 'Created Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'modifiedDate',
            headerName: 'Modified Date',
            hide: true,
            minWidth: 225,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: renderCellExpand,
        },
        {
            field: 'metadata',
            hideable:false,
            headerName: 'Metadata Values',
            minWidth: 305,
            flex: 1,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {

                if (params.value) {
                    params.value.sort(compareNameIgnoreCase);
                }

                const getConfidenceText = (value) => {
                    let confidenceText;
                    if (value.confidence && value.confidence >= 0.0) {
                        let confidenceTextColor = (value.confidence >= 0.8) ? "green" : "red";
                        confidenceText = <span style={{ color: { confidenceTextColor } }}>
                            <b>({Math.floor(value.confidence * 100)}%)</b>
                        </span>
                    }
                    return confidenceText;
                };

                return (
                    <div>
                        <p>
                            <HtmlTooltip followCursor placement="top" title={
                                <>
                                    <h4 style={{ backgroundColor: '#E5E4E2' }}>Metadata Values</h4>
                                    <table border='1' style={{ borderCollapse: 'collapse' }}>
                                        {params.value && params.value.map((metaVal, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td nowrap style={{ padding: '2px' }}>
                                                        <b>{metaVal.name}{getConfidenceText(metaVal)}</b>
                                                    </td>
                                                    <td nowrap style={{ padding: '2px' }}>
                                                        {metaVal.value}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </table>
                                </>
                            }>
                                <MetadataComponent>
                                    {
                                        params.value && params.value.map((metaVal, index) =>
                                            generateMetaValue(metaVal, index)
                                        )
                                    }
                                </MetadataComponent>
                            </HtmlTooltip>

                        </p>
                    </div>
                );
            }
        }

    ];

    const getColumns = () => {
        return (hasAssetsUseManage && columns) || columns.filter(obj => { return obj.field !== "actions"});
    };

    const toggleColumnPinning = () => {
        return (hasAssetsUseManage && 'columnPinning') || '';
    };

    /*
    const MetadataComponent = React.forwardRef(function MetadataComponent(props, ref) {
        return <div {...props} ref={ref}>
            {props.children}
        </div>
    });
    */

    const generateMetaValue = (value, index) => {
        let formatText = "";
        let confidenceText = "";
        if (value.confidence && value.confidence >= 0.0) {
            let confidenceTextColor = (value.confidence >= 0.8) ? "green" : "red";
            confidenceText =
                <span style={{ color: confidenceTextColor }}>
                    <b>({Math.floor(value.confidence * 100)}%)</b>
                </span>
        }

        formatText = <>{(index ? ', ' : '')}{value.name}{confidenceText}</>

        return formatText;
    };

    const fetchData = async (apiURL2, qparams) => {
        //console.log('inside fetch customer data:', qparams);

        /*
        let message = "Loading customer data ...";
    
        setNotify({
            isOpen: true,
            message: message,
            severity: 'info'
        });
    */
        setIsloading(true);
        await fetchAPIData(apiURL2, qparams)
            .then((data) => {
                // console.log("Updating table data: ", data);
                setApiData(data);
                setCoreDocuments(data);
                // clear the reload false now that data is loaded
                setReload(false);
                setIsloading(false);
            })
            .catch((err) => {
                console.log(err);

                let message = `Failed to load core document data \n\n ${err.response.statusText} : ${err.response.data.message}`;
                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

                // clear data since user may have previously loaded data that is already displayed
                setApiData([]);
                setReload(false);
                setIsloading(false);
            });
    };

    const viewRowData = (param, event) => {

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = param.row;

        setRowJsonData(JsonData);
        setMode('view');
        setReadOnly(true);
        setOpen(true);
    };

    const formatData = (data) => {
        data.forEach((obj) => {
            obj.startTime = data.startTime > 0 ? new Date(data.startTime).toISOString() : "";
            obj.endTime = data.endTime > 0 ? new Date(data.endTime).toISOString() : "";

            obj.tasks.forEach((obj) => {
                obj.startTime = obj.startTime > 0 ? new Date(obj.startTime).toISOString() : "";

                obj.endTime = obj.endTime > 0 ? new Date(obj.endTime).toISOString() : "";

                obj.scheduledTime = obj.scheduledTime > 0 ? new Date(obj.scheduledTime).toISOString() : "";

                // convert object to JSON string format
                obj.outputData = JSON.stringify(obj.outputData, null, 2);
            });
        });
    };

    const fetchIdpWorkflowCoreDocumentStatus = (companyId, documentGUID, docState) => {

        let idpWorkflowDocumentStatusUrl = `/api/companies/${companyId}/idp/workflows/documents/${documentGUID}?origination=${origination}&documentState=${docState}`;

        axios({
            method: "GET", url: idpWorkflowDocumentStatusUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                const JsonData = response.data.data;

                // check if any data exists. No need to show dialog if empty data
                if (JsonData.length) {

                    formatData(JsonData);

                    setIdpWorkflowCoreDocumentStatusJsonData(JsonData);
                    setOpenIdpWorkflowCoreDocumentStatusDialog(true);

                    /*
                    setIdpWorkflowCoreDocumentStatusJsonData(JsonData);
                    setIdpWorkflowCoreDocumentStatusMode('view');
                    setOpenIdpWorkflowCoreDocumentStatusDialog(true);
                    */
                } else {
                    let message = `No IDP workflow status data exists for Core document ${documentGUID}`;

                    setNotify({
                        isOpen: true,
                        message: message,
                        severity: 'info'
                    });
                }

            }).catch(error => {
                console.log('error in fetch idp workflow document status api call:', error);

                let message = `Failed to fetch idp workflow document status for workflow [${companyId}, ${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });

            });
    };

    const viewEditData = useCallback((rowData) => () => {
        // console.log("view/edit icon clicked", rowData);

        // remove the id from table data as table data only not part of json stored
        const {
            id,
            ...JsonData
        } = rowData;

        setRowJsonData(JsonData);
        setMode('edit');
        setReadOnly(false);
        setOpen(true);
    }, []);


    const reprocessCoreDocument = (companyId, documentGUID) => {
        let reprocessUrl = `/api/companies/${companyId}/coreDocuments/${documentGUID}/reprocess`;

        axios({
            method: "put", url: reprocessUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Reprocess inititated for core document [${documentGUID}]

                Please wait a few minutes and reload the table to view reprocess state`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });



            }).catch(error => {
                console.log('error in reprocess core document api call:', error);

                let message = `Failed to initiate reprocess for core document [${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const reprocessData = (rowData) => {
        // console.log("reprocess icon clicked", rowData);

        let title = "Reprocess Core Documents";
        let msg = `Are you sure to reprocess the selected core document?`;

        let documentGUID = rowData.documentGUID;
        let companyId = rowData.companyId;

        let confirmProps = {
            title,
            msg,
            confirmCallback: () => reprocessCoreDocument(companyId, documentGUID)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);

    };


    const deleteCoreDocument = (companyId, documentGUID, permanentDelete = false) => {

        let deleteUrl = `/api/companies/${companyId}/coreDocuments/${documentGUID}`;

        if (permanentDelete) {
            deleteUrl += `?permanent=${permanentDelete}`;
        }

        axios({
            method: "delete", url: deleteUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Deleted core document [${documentGUID}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // do we need to reload??
                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in delete core document api call:', error);

                let message = `Failed to delete core document [${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const deleteData = useCallback((rowData) => () => {
        // console.log("delete icon clicked", rowData);

        let documentGUID = rowData.documentGUID;
        let companyId = rowData.companyId;

        deleteCoreDocument(companyId, documentGUID);

    }, []);

    const restoreCoreDocument = (companyId, documentGUID) => {

        let restoreUrl = `/api/companies/${companyId}/coreDocuments/${documentGUID}`;

        axios({
            method: "patch", url: restoreUrl,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {

                let message = `Restored core document [${documentGUID}]`;

                setNotify({
                    isOpen: true,
                    message: message,
                    severity: 'info'
                });

                // clear data before reload
                setApiData([]);
                setReload(true);

            }).catch(error => {
                console.log('error in restore core document api call:', error);

                let message = `Failed to restore core document [${documentGUID}]: \n\n ${error.response.statusText} : ${error.response.data.message}`;

                setNotify({
                    isOpen: true,
                    alertTitle: 'Request failed',
                    message: message,
                    severity: 'error'
                });
            });
    };

    const restoreData = useCallback((rowData) => () => {
        // console.log("restore icon clicked", rowData);

        let documentGUID = rowData.documentGUID;
        let companyId = rowData.companyId;

        restoreCoreDocument(companyId, documentGUID);

    }, []);

    const permanentDeleteData = useCallback((rowData) => () => {
        // console.log("permanent delete icon clicked", rowData);

        let title = "Permanently Delete Core Document?";
        let msg = `Are you sure you want to permantly delete core document?`;

        let documentGUID = rowData.documentGUID;
        let companyId = rowData.companyId;
        let permanentDelete = true;

        deleteCoreDocument(companyId, documentGUID, permanentDelete);

        let confirmProps = {
            title,
            msg,
            confirmCallback: () => deleteCoreDocument(companyId, documentGUID, permanentDelete)
        };

        setConfirmProps(confirmProps);

        setConfirmOpen(true);
    }, []);

    const getActionButtons = (params) => {
        let actionButtons = [];

        if (params.row.trashDate == null) {

            // create edit button
            let editButton = <GridActionsCellItem icon={
                <Tooltip title="Edit" arrow placement="right">
                    <EditIcon />
                </Tooltip>}
                label='View/Edit'
                onClick={viewEditData(params.row)}
            />;

            hasAssetsUsePermission && actionButtons.push(editButton);


            if (params.row.mlEnabled) {
                let reprocessButton = <GridActionsCellItem icon={
                    <Tooltip title="Reprocess" arrow placement="right">
                        <AutorenewIcon />
                    </Tooltip>}
                    label='Reprocess'
                    onClick={() => {
                        //setConfirmOpen(true);
                        reprocessData(params.row)
                    }}
                />;

                hasAssetsUsePermission && actionButtons.push(reprocessButton);
            }

            let deleteButton = <GridActionsCellItem icon={
                <Tooltip title="Delete" arrow placement="right">
                    <DeleteIcon />
                </Tooltip>}
                label='Delete'
                onClick={deleteData(params.row)}
            />;

            hasAssetsUsePermission && actionButtons.push(deleteButton);

        } else {

            let restoreButton = <GridActionsCellItem icon={
                <Tooltip title="Restore" arrow placement="right">
                    <RestoreFromTrashIcon />
                </Tooltip>}
                label='Restore'
                onClick={restoreData(params.row)}
            />;

            hasAssetsUsePermission && actionButtons.push(restoreButton);

            let deleteForeverButton = <GridActionsCellItem icon={
                <Tooltip title="Permanent Delete" arrow placement="right">
                    <DeleteForeverIcon />
                </Tooltip>}
                label='Permanent Delete'
                onClick={permanentDeleteData(params.row)}
            />;

            hasAssetsUsePermission && actionButtons.push(deleteForeverButton);

        }

        return actionButtons;

    };

    const handleJsonChange = (formData) => {
        // console.log("Dialog JSON has changed", formData);

        setRowJsonData(formData);

    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleFormChange = (data) => {
        setRowJsonData(data.formData);
    }

    const validateSchema = (coreDocumentsSchema, data) => {
        // console.log('got json schema', coreDocumentsSchema);
        const validate = ajv.compile(coreDocumentsSchema);
        const valid = validate(data);
        if (!valid) {
            console.log(validate.errors);
            return false;
        }
        return true;
    }

    const saveCoreDocumentsData = (formData) => {

        // console.log('called save core documents:', formData);
        // console.log('current mode:', mode);

        let cleanedObj = cleanObject(formData);

        if (mode === 'edit') {
            if (validateSchema(coreDocumentsSchema, cleanedObj)) {
                //call save API
                // console.log('validated successfully..');
                updateCoreDocuments(cleanedObj);
            }
        }
    }

    const updateCoreDocuments = (data) => {
        try {
            // console.log('inside core documents update api..');

            let fields = ['name', 'documentType', 'pageCount', 'mlEnabled', 'metadata'];

            let payload = {};
            // create update payload. only certain fields are necessary or valid
            for (let field of fields) {
                payload[field] = data[field];
            }

            let updateUrl = `/api/companies/${data.companyId}/coreDocuments/${data.documentGUID}`;

            axios({
                method: "put",
                url: updateUrl,
                data: payload,
                headers: { 'insightUserId': getUser(), 'companyId': getCompanyId(), 'Authorization': getToken() }
            })
                .then(response => {
                    if (response.status === 200) {
                        let message = `Updated core document [${data.documentGUID}]`;

                        setNotify({
                            isOpen: true,
                            message: message,
                            severity: 'info'
                        });

                        // console.log('got response from core documents update:', response);
                        setReload(true);
                        setOpen(false);
                    }

                }).catch(error => {

                    let message = `Failed to update core document data \n\n ${error.response.statusText} : ${error.response.data.message}`;
                    setNotify({
                        isOpen: true,
                        alertTitle: 'Request failed',
                        message: message,
                        severity: 'error'
                    });
                    console.log('error in update core documents api call:', error.response.data.message);
                });
        }
        catch (e) {
            console.log(e);
            let message = `Failed to update core document data `;
            setNotify({
                isOpen: true,
                alertTitle: 'Request failed',
                message: message,
                severity: 'error'
            });
        }
    };

    const handleIdpWorkflowCoreDocumentStatusClose = () => {
        setOpenIdpWorkflowCoreDocumentStatusDialog(false);
    };

    const assetsUseManagePermission = assetsPermissionOptions.filter(item => item !== 'assets.view');
    const hasAssetsUsePermission = hasPermission(permissions, assetsUseManagePermission);

    return (
        <>
            <div id="coreDocumentfilterContainer" style={{ marginTop: '0px', marginLeft: '8px' }}>
                <Filter permission={assetsPermissionOptions} fields={createFilterOptions(fieldData)} sortFields={createSortFieldOptions(sortFieldData)} apiURL={apiURL} fetchData={fetchData} setNotify={setNotify} reload={reload} useCompanyId={true} totalLabel={totalLabel} includeDeleted={true} includeCoreDocActions={hasAssetsUsePermission} tabName={'documentCoreTab'} />
            </div>


            <Divider />

            <div id="coreDocumentTableContainer" className={toggleColumnPinning()}>
                <div >
                    <Table data={apiData} columns={getColumns()} hiddenColumns={generateHiddenColumns(columns)} viewRowData={viewRowData} isLoading={isLoading} />
                </div>
            </div>

            <ActionDialog
                open={open}
                mode={mode}
                onClose={handleClose}
                onSave={() => handleSave(formId, rowJsonData, saveCoreDocumentsData)}
                title="Core Documents Information"
                propertiesTabContent={<CoreDocumentsDialog formId={formId}
                    coreDocumentsSchema={coreDocumentsSchema}
                    uiSchema={uiSchema}
                    saveCoreDocumentsData={saveCoreDocumentsData}
                    formData={rowJsonData} handleFormChange={handleFormChange}
                    readOnly={readOnly} />
                }
                jsonDataName="documents"
                JSONTabContent={rowJsonData}
                handleJsonChange={handleJsonChange}
                saveButtonText={saveButtonText}
            />



            <DocumentIDPWorkflowStatusDialog
                open={openIdpWorkflowCoreDocumentStatusDialog}
                onClose={handleIdpWorkflowCoreDocumentStatusClose}
                data={idpWorkflowCoreDocumentStatusJsonData}
                viewTitle={viewTitle}
                jsonDataName={jsonDataName}
            />


            <ConfirmDialog
                title={confirmProps.title}
                open={confirmOpen}
                onClose={handleConfirmClose}
                setOpen={setConfirmOpen}
                cancelButtonText={confirmProps.cancelButtonText}
                confirmButtonText={confirmProps.confirmButtonText}
                onConfirm={confirmProps.confirmCallback}
            >
                {confirmProps.msg}
            </ConfirmDialog>

        </>
    );
}

export default DocumentCoreTabPanel;